import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import MarkerIcon from '@shared/marker-icon';
import { getMarkerAnchorStyle } from '@utils/map-utils';
import styles from './point.scss';

// zIndex tiers across this app's AdvancedMarkers (see also location-button, marker-overlaps,
// search-marker) - Google's docs warn that mixing markers with an explicit zIndex and markers
// without one causes unexpected visual results, so every AdvancedMarker here gets one, and the
// ranges are chosen so clusters always beat plain points, and "my location"/highlighted points
// always beat clusters - matching what OverlayView.FLOAT_PANE gave "always on top" for free
// before AdvancedMarkerElement (which has no pane system, only zIndex).
export const POINT_Z_INDEX = 10;
export const HIGHLIGHTED_POINT_Z_INDEX = 50000;

const Point = ({ highlighted, icon, options, position }) => {
  if (!icon?.url) {
    return null;
  }
  if (highlighted) {
    return (
      <AdvancedMarker
        clickable={false}
        position={position}
        zIndex={HIGHLIGHTED_POINT_Z_INDEX}
        {...getMarkerAnchorStyle(icon)}
      >
        <img alt="" className={styles.selectedPoint} draggable={false} src={icon.url} />
      </AdvancedMarker>
    );
  }
  return (
    <AdvancedMarker
      clickable={Boolean(options?.clickable)}
      position={position}
      zIndex={POINT_Z_INDEX}
      {...getMarkerAnchorStyle(icon)}
    >
      <MarkerIcon icon={icon} />
    </AdvancedMarker>
  );
};

Point.propTypes = {
  highlighted: PropTypes.bool,
  icon: PropTypes.object,
  options: PropTypes.object,
  position: PropTypes.object
};

export default memo(Point);
